import React from "react";
import API from '../Utils/api'
import Axios from 'axios'
import Cleave from "cleave.js/react"
import {getUsuarioFromStorage} from "../Utils/usuarioHelper";
import MasterTemplate from "./MasterTemplate";
import moment from 'moment';
import { Link } from 'react-router-dom';

export class EditarPedido extends React.Component {
  constructor(props) {
    window.localStorage.setItem("rotaAtual", window.location.href.split('/')[3]);
super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem("user")),
      pedido: JSON.parse(localStorage.getItem("pedido")),
      clientes: [],
      clienteSelecionado: null
    }
    this.getClientesPorCambista()
    this.getPedido()
  }

  async getPedido(){
    try {
      const response = await API.post("/api/pedidos/id", {
          id: this.state.pedido._id
      });

      this.setState({pedido: response.data});
  } catch (err) {
      console.log(err);
  }
  }

  setCliente(e){
    this.state.clienteSelecionado = JSON.parse(e.target.value);
    this.setState({clienteSelecionado : JSON.parse(e.target.value)})
  }

  async getClientesPorCambista() {
      try {
        const response = await API.post("/api/usuarios/listar-por-tutor", {
            tutorId: this.state.pedido.cambistaId._id
        });
        this.setState({clientes: response.data.sort(this.compararNome)});
    } catch (err) {
        console.log(err);
    }

  
  };


  async updatePedido(){
    try {
      var axiosInstance = new Axios.create({
          baseURL: window.localStorage.getItem("apiUrl")
      });
      this.state.pedido.clienteId = this.state.clienteSelecionado;
      this.state.pedido.transacaoId.receptorId = this.state.clienteSelecionado;
      const response1 = await axiosInstance.post("pedidos/modifica-pedido", {id: this.state.pedido._id, pedido: this.state.pedido})
      const response2 = await axiosInstance.post("transacoes/modifica-transacao", {id: this.state.pedido.transacaoId, transacao: this.state.pedido.transacaoId})
      if(response1.data && response2.data){
        window.location.reload()
      }
  } catch (err) {
      console.log(err);
  }
  }

compararNome (a, b) {
  if (a.nome.toLowerCase() > b.nome.toLowerCase()) {
    return 1;
  }
  if (a.nome.toLowerCase() < b.nome.toLowerCase()) {
    return -1;
  }

  return 0
}

formatDate(data) {
  return moment(data).add(0,'days').format('DD-MM-YYYY')
  }

  render() {
    return (
      <MasterTemplate label="Editar Pedidos">
        <div className="container">
          <div className="row">
          <select onChange={this.setCliente.bind(this)} style={{maxWidth: '15em'}} class="ml-5 custom-select">
                      <option value={JSON.stringify(null)} selected>Selecione um cliente</option>
                      {this.state.clientes.length > 0 ?this.state.clientes.map(cliente => {
                         return <option value={JSON.stringify(cliente)}>{cliente.nome} - {cliente.telefone}</option>
                      }) :  ""}
                    </select>


          <button className="btn-fill btn btn-success" onClick={this.updatePedido.bind(this)}>Alterar pedido</button>
                    
          </div>
          {this.state.pedido != null?
          
          
          <div className={'container bg-white border w-100 p-2 pl-5 m-2'} >
            <div className="row">
                    <span className="font-weight-bold" style={{fontSize: '1.5em'}}>Dados do pedido</span>
            </div>
            <div className="row">
                    <span className="font-weight-bold" style={{fontSize: '1em'}}>Código: </span>
                          <span className="ml-4 font-weight-bold text-danger" style={{fontSize: '1em'}}>{this.state.pedido.codigo}</span>
            </div>
            <div className="row">
                    <span className="font-weight-bold" style={{fontSize: '1em'}}>Quantidade de cartelas: </span>
                          <span className="ml-4 font-weight-bold text-danger" style={{fontSize: '1em'}}>{this.state.pedido.cartelas.length}</span>
            </div>
            <div className="row">
                    <span className="font-weight-bold" style={{fontSize: '1em'}}>Cliente: </span>
                          <span className="ml-4 font-weight-bold text-danger" style={{fontSize: '1em'}}>{this.state.pedido.clienteId.nome}</span>
            </div>
            <div className="row">
                    <span className="font-weight-bold" style={{fontSize: '1em'}}>Cambista: </span>
                          <span className="ml-4 font-weight-bold text-danger" style={{fontSize: '1em'}}>{this.state.pedido.cambistaId.nome}</span>
            </div>
            <div className="row">
                    <span className="font-weight-bold" style={{fontSize: '1em'}}>Gerente: </span>
                          <span className="ml-4 font-weight-bold text-danger" style={{fontSize: '1em'}}>{this.state.pedido.gerenteId? this.state.pedido.gerenteId.nome : 'Ainda sem gerente'}</span>
            </div>
            <div className="row">
                    <span className="font-weight-bold" style={{fontSize: '1em'}}>Data: </span>
                          <span className="ml-4 font-weight-bold text-danger" style={{fontSize: '1em'}}>{this.formatDate(this.state.pedido.data)}</span>
            </div>
            <div className="row">
              {/* <span className="font-weight-bold text-secondary" style={{fontSize: '1em'}}>Recebido aguardando validação da banca!</span> */}
            </div>


          </div>
          
          
          
          : ""}
          
        </div>
      </MasterTemplate>
    );
  }
}

export default EditarPedido;
